import React from "react";
import Navbar from "../../homePage/navBarMenu/navBarMenu";

const AllBolg = () => {
  return (
    <>
      <Navbar />
      <div style={{ height: "100vh" }} className="mt-5">
        <h1 className="text-center">Update Blog Coming soon</h1>
      </div>
    </>
  );
};

export default AllBolg;
